import { useState } from 'react';
import Paper, { PaperProps } from '@mui/material/Paper';
import { DndContext, useDraggable, DragEndEvent } from '@dnd-kit/core';
import { DRAGGABLE_DIALOG_ID } from '..';

function PaperComponent({
  position,
  ...props
}: PaperProps & { position: { x: number; y: number } }) {
  const { setNodeRef, transform, isDragging } = useDraggable({
    id: DRAGGABLE_DIALOG_ID,
  });

  // Combine the saved position with the current drag transform
  const combinedTransform =
    isDragging && transform
      ? `translate3d(${position.x + transform.x}px, ${position.y + transform.y}px, 0)`
      : `translate3d(${position.x}px, ${position.y}px, 0)`;

  const style = {
    transform: combinedTransform,
    opacity: isDragging ? 0.95 : 1,
  };

  return (
    <Paper {...props} ref={setNodeRef} style={{ ...style, ...props.style }} />
  );
}

export function DraggablePaper(props: PaperProps) {
  const [position, setPosition] = useState({ x: 0, y: 0 });

  const handleDragEnd = (event: DragEndEvent) => {
    const { delta, active } = event;
    if (delta) {
      setPosition((prev) => {
        const newX = prev.x + delta.x;
        const newY = prev.y + delta.y;

        const viewportWidth = window.innerWidth;
        const viewportHeight = window.innerHeight;

        const draggedElement = active.rect.current.translated;
        const modalWidth = draggedElement?.width || 600;
        const modalHeight = draggedElement?.height || 400;

        const minTitleVisible = 100;

        const minX = -(modalWidth - minTitleVisible);
        const maxX = viewportWidth - minTitleVisible;
        const minY = -(viewportHeight / 2 - modalHeight / 2);
        const maxY = viewportHeight / 2;

        const constrainedX = Math.max(minX, Math.min(maxX, newX));
        const constrainedY = Math.max(minY, Math.min(maxY, newY));

        return {
          x: constrainedX,
          y: constrainedY,
        };
      });
    }
  };

  return (
    <DndContext onDragEnd={handleDragEnd}>
      <PaperComponent {...props} position={position} />
    </DndContext>
  );
}
